import { Box, Chip, Typography } from "@material-ui/core";
import React from "react";
import OpenApiSpecIcon from "legacy-components/icons/OpenApiSpecIcon";
import { SpecEditor } from "./SpecEditor";

interface SpecDetailsProps {
  specName?: string;
  apiId: string;
  version: string;
  specId: string;
  specFile: string;
  refreshDeployments: ()=>void;
  serviceId: string;
}

export const SpecDetails: React.FC<SpecDetailsProps> = ({ specName, apiId, version, specId, specFile, refreshDeployments, serviceId }) => {
     return (
    <Box style={{ borderColor: "#0063A3", borderStyle: "solid", borderWidth: "2px", display: "flex", alignItems: "center", height: "91px", width: "450px" , justifyContent: "space-evenly" }}>
          <OpenApiSpecIcon style={{ width: "50px", height: "50px" }} />
      <Box style={{ minWidth: '120px' }}>
        <Typography variant="body1" style={{ fontSize: '14px', fontWeight: 500 }}>
            {specName}
        </Typography>
      </Box>
      <Chip label={"API"} variant={"outlined"} style={{borderColor: "green", color: "green"}}/>
      <SpecEditor apiId={apiId} version={version} specId={specId} specFile={specFile} refreshDeployments={refreshDeployments} serviceId={serviceId}>

      </SpecEditor>
    </Box>
  );
};
